import dayjs from 'dayjs';

export const getFormattedDate = (date) => (date ? dayjs(date).format('D MMM YYYY') : '');
